export default "__VITE_ASSET__D0zUYV1C__"